import { dfs, navigatePage } from '@/common/utils.ts'
import { useNavigate } from 'react-router-dom'
import microApp from '@micro-zoe/micro-app'
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import { isNil } from 'lodash-es'

export default function useNavigateMicro() {
  const { menuRouteCache } = useGlobalStore(
    useShallow((state: any) => ({
      menuRouteCache: state.menuRouteCache,
    }))
  )

  const getAppFirstMenu = menu => {
    let appPath = ''
    let path = ''
    dfs([menu], d => {
      if (d?.path && isNil(d.children) || d?.path && d.level === 2) {
        appPath = d.apppath || ''
        path = d.path
        return true
      }
    })
    return { appPath, path }
  }

  const getEntranceMenu = (appData, menu, entranceUrl) => {
    let appPath = ''
    let path = ''
    dfs([menu], d => {
      if (appData.app.code === d.code) {
        appPath = d.path || ''
      }

      if (!path && d.level === 2 && d.path) {
        path = d.path
      }

      if (!d.children && d.path === entranceUrl) {
        path = entranceUrl
        return true
      } else if (!d.children && d.path === entranceUrl.replace(d.apppath, '')) {
        path = entranceUrl.replace(appPath, '')
        return true
      }
    })
    return { appPath, path }
  }

  const navigate = useNavigate()
  const navigateMicroPage = (appData, menu) => {
    let menuItem = {
      path: '',
      appPath: '',
    }
    // console.log(menu, appData.app.entranceUrl)
    const cachePath = menuRouteCache[menu.nid] // menu = selectedApp
    // const cachePath = '' // menu = selectedApp
    if (cachePath) {
      menuItem.appPath = menu.path
      menuItem.path = cachePath.replace(menu.path, '')
    } else if (appData?.app?.entranceUrl?.startsWith?.('/')) {
      const url = appData.app.entranceUrl
      menuItem = getEntranceMenu(appData, menu, url)
      // navigate(appData.app.entranceUrl)
    } else {
      // 应用选择 跳转 - 第一个页面
      menuItem = getAppFirstMenu(menu)
    }
    if (appData.app.urlPrefix === '/') {
      return navigateMain(appData, menuItem)
    }
    if (menuItem.path) {
      // navigate(path)
      microApp.router.push({ name: menuItem.appPath, path: menuItem.appPath + menuItem.path })
      navigatePage(menuItem.appPath, menuItem.path, navigate)
    }
  }

  const navigateMain = (appData, menu) => {
    let menuItem = {
      path: '',
    }
    const cachePath = menuRouteCache[menu.nid] //
    if (cachePath) {
      // menuItem.appPath = menu.path
      menuItem.path = cachePath
    } else if (appData?.app?.entranceUrl?.startsWith?.('/')) {
      const url = appData.app.entranceUrl
      menuItem = getEntranceMenu(appData, menu, url)
      // navigate(appData.app.entranceUrl)
    } else {
      // 应用选择 跳转 - 第一个页面
      menuItem = getAppFirstMenu(menu)
    }

    // console.log(appData, menu, menuItem)
    if (menuItem.path) {
      navigate(menuItem.path)
    }
  }

  return [navigateMicroPage, navigateMain]
}
